import React, { Fragment, useState, useEffect } from "react";
import _ from "lodash";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { Grid, IconButton, Chip } from "@material-ui/core";
import { makeStyles, createStyles } from "@material-ui/core/styles";
import * as C from "components";
import * as H from "helper";
import TimeLineIcon from "@material-ui/icons/Timeline";
import MUIDataTable from "mui-datatables";
import { createMuiTheme, MuiThemeProvider } from "@material-ui/core/styles";
import {
  setCurrentPage,
  getA2ESurvey,
} from "actions";

const getMuiTheme = () =>
  createMuiTheme({
    overrides: {
      MUIDataTable: {
        filterPaper: {
          width: "500px", // フィルターダイアログの幅を500pxに設定
        },
      },
    },
  });

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      display: "flex",
      position: "fixed",
      backgroundColor: "#fafafa",
      zIndex: 1000,
      width: "100%",
    },
    alignLeft: {
      lineHeight: "18px",
      textAlign: "left",
    },
    summaryCenter: {
      textAlign: "center",
    },
    cvrHead: {
      textAlign: "center",
      fontSize: 12,
      fontWeight: "normal",
      borderBottom: "1px solid rgba(224, 224, 224, 1)",
    },
    flexItemLeftBox: {
      marginTop: 28,
      alignSelf: "center",
      paddingLeft: 8,
      paddingRight: 8,
      borderRight: "1px solid #dcdcdc",
    },
  })
);

const SurveyList = ({
  setCurrentPage,
  tableRowSelected,
  survey,
  getA2ESurvey,
}) => {
  const classes = useStyles();
  const [selectedCampaign, setSelectedCampaign] = useState([]);

  useEffect(() => {
    setCurrentPage(window.location.pathname);
    getA2ESurvey();
  }, []);

  const getReportUrl = (cid) => {
    let url = "/a2e/report/" + cid;
    return url;
  };

  const getSurveyData = (data) => {
    if (data.length > 0) {
      let allDataArray = [],
        eachDataArray = [];
      for (let i = 0; i < data.length; i++) {
        eachDataArray.push(data[i]["status"]);
        eachDataArray.push(data[i]["alias"]);
        eachDataArray.push(data[i]["versionedQuizId"]);
        eachDataArray.push(data[i]["quizText"]);
        eachDataArray.push(data[i]["optionText"]);
        eachDataArray.push(data[i]["selectionCount"]);
        eachDataArray.push(data[i]["startDate"]);
        eachDataArray.push(data[i]["endDate"]);
        eachDataArray.push(data[i]["duration"]);
        eachDataArray.push(data[i]["remainDays"]);
        allDataArray.push(eachDataArray);
        eachDataArray = [];
      }
      return allDataArray;
    }
  };

  const getColumns = () => {
    let returningColumn = columns;
    if (
      localStorage.getItem("access_key") !== process.env.REACT_APP_SUPERUSER
    ) {
      returningColumn.pop();
    }
    return returningColumn;
  };

  const options = {
    filterType: "dropdown",
    filter: true,
    pagination: true,
    search: true,
    print: false,
    download: true,
    downloadOptions: {
      filename: "アンケート一括データ",
      filterOptions: {
        useDisplayedColumnsOnly: true,
        useDisplayedRowsOnly: true,
      },
    },
    selectableRows: "none",
    rowsPerPage: 100,
    rowsSelected: tableRowSelected,
    textLabels: {
      body: {
        noMatch: "データを取得中です。",
        toolTip: "",
      },
      toolbar: {
        search: "検索",
        viewColumns: "列の表示",
        downloadCsv: "CSVダウンロード",
        filterTable: "テーブルのフィルター",
      },
      viewColumns: {
        title: "表示する列",
        titleAria: "テーブルの列の表示/非表示",
      },
      pagination: {
        next: "次のページ",
        previous: "前のページ",
        rowsPerPage: "表示件数",
      },
      filter: {
        all: "全て",
        title: "フィルター",
        reset: "リセット",
      },
      selectedRows: {
        text: "レコードを選択",
        delete: "削除",
        deleteAria: "選択したレコードを削除する",
      },
    },
    rowsPerPageOptions: [10, 50, 100],
  };

  let columns = [
    {
      name: "状況",
      options: {
        filter: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Chip
              size="small"
              label={value}
              style={{
                backgroundColor:
                  value.indexOf("Active") !== -1 ? "#aeeab2" : "#f4a915",
              }}
            />
          );
        },
      },
    },
    {
      name: "対象",
      options: {
        filter: true,
        customFilterListRender: (v) => `対象: ${v}`,
        customBodyRender: (value) => {
          return <div className={classes.alignLeft}>{value}</div>;
        },
      },
    },
    {
      name: "クイズID",
      options: {
        filter: false,
        customFilterListRender: (v) => `名前: ${v}`,
        customBodyRender: (value) => {
          return <div className={classes.alignLeft}>{value}</div>;
        },
      },
    },
    {
      name: "クイズ",
      options: {
        filter: false,
        customFilterListRender: (v) => `名前: ${v}`,
        customBodyRender: (value) => {
          return <div className={classes.alignLeft}>{value}</div>;
        },
      },
    },
    {
      name: "選択肢",
      options: {
        filter: false,
        customFilterListRender: (v) => `名前: ${v}`,
        customBodyRender: (value) => {
          return <div className={classes.alignLeft}>{value}</div>;
        },
      },
    },
    {
      name: "件数",
      options: {
        filter: false,
        customFilterListRender: (v) => `名前: ${v}`,
        customBodyRender: (value) => {
          return <div>{value}</div>;
        },
      },
    },
    {
      name: "開始日",
      options: {
        filter: false,
        customFilterListRender: (v) => `名前: ${v}`,
        customBodyRender: (value) => {
          return <div>{value}</div>;
        },
      },
    },
    {
      name: "終了日",
      options: {
        filter: false,
        customFilterListRender: (v) => `名前: ${v}`,
        customBodyRender: (value) => {
          return <div>{value}</div>;
        },
      },
    },
    {
      name: "全日数",
      options: {
        filter: false,
        customFilterListRender: (v) => `名前: ${v}`,
        customBodyRender: (value, tableMeta, updateValue) => {
          return <div>{value}日</div>;
        },
      },
    },
    {
      name: "残り日数",
      options: {
        filter: false,
        customFilterListRender: (v) => `名前: ${v}`,
        customBodyRender: (value, tableMeta, updateValue) => {
          return <div>{value}日</div>;
        },
      },
    },
    // {
    //   name: "レポート",
    //   options: {
    //     filter: false,
    //     sort: false,
    //     viewColumns: false,
    //     customBodyRender: (value, tableMeta, updateValue) => {
    //       return (
    //         <Link
    //           to={getReportUrl(tableMeta.rowData[tableMeta.rowData.length - 1])}
    //           target="_blank"
    //         >
    //           <IconButton aria-label="詳細">
    //             <TimeLineIcon fontSize="small" />
    //           </IconButton>
    //         </Link>
    //       );
    //     },
    //   },
    // },
  ];

  return (
    <Fragment>
      <C.ContentWrapper>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <MUIDataTable
              title={`アンケート：${survey.length}`}
              data={getSurveyData(survey)}
              columns={getColumns()}
              options={options}
            />
          </Grid>
        </Grid>
      </C.ContentWrapper>
    </Fragment>
  );
};

SurveyList.propTypes = {
  classes: PropTypes.object,
  survey: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
};

const mapStateToProps = (state) => ({
  tableRowSelected: state.page.tableRowSelected,
  survey: state.a2e.survey,
});

const mapDispatchToProps = (dispatch) => ({
  setCurrentPage: (param) => dispatch(setCurrentPage(param)),
  getA2ESurvey: () => dispatch(getA2ESurvey()),
});

export default connect(mapStateToProps, mapDispatchToProps)(SurveyList);
